var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_8617)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_912_8617",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_912_8617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "#E70B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6692 10.3824L15.2859 11.1144L15.5502 9.56284L14.4312 8.46244L15.9788 8.23444L16.6692 6.82324L17.3597 8.23564L18.9073 8.46364L17.7883 9.56164L18.0526 11.1132",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3097 13.2C13.6109 13.2 15.4764 11.3196 15.4764 9.00005C15.4764 6.68045 13.6109 4.80005 11.3097 4.80005C9.00854 4.80005 7.14307 6.68045 7.14307 9.00005C7.14307 11.3196 9.00854 13.2 11.3097 13.2ZM12.5002 12C14.1431 12 15.4764 10.656 15.4764 9.00005C15.4764 7.34405 14.1431 6.00005 12.5002 6.00005C10.8574 6.00005 9.52402 7.34405 9.52402 9.00005C9.52402 10.656 10.8574 12 12.5002 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0.600098H2.38093C1.39471 0.600098 0.595215 1.40599 0.595215 2.4001V15.6001C0.595215 16.5942 1.39471 17.4001 2.38093 17.4001H22.619C23.6052 17.4001 24.4047 16.5942 24.4047 15.6001V2.4001C24.4047 1.40599 23.6052 0.600098 22.619 0.600098Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_8617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.8cc8b18dd9255244d87463bc797c5632.svg";
export { ForwardRef as ReactComponent };